import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubbleWideSparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBubbleWideSparkle"><Path d="M16.0518 3.05176L13 4.22656V7.77344L16.0518 8.94727L17.2266 12H20.7734L21.9473 8.94727L22.002 8.92578V19.0361H15.376L11.9941 21.8379L8.65137 19.0361H2.00195V3H16.0713L16.0518 3.05176Z" fill="currentColor"/><Path d="M22.002 3.07227L21.9473 3.05176L21.9277 3H22.002V3.07227Z" fill="currentColor"/><Path d="M19.4 2H18.6L17.6 4.6L15 5.6V6.4L17.6 7.4L18.6 10H19.4L20.4 7.4L23 6.4V5.6L20.4 4.6L19.4 2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBubbleWideSparkle;
